import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "csp_token";

export { TOKEN_KEY };

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    // localStorage may throw in Safari private mode or sandboxed iframes — treat as logged out.
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // Storage unavailable (private mode / quota). Auth becomes session-only, which is acceptable.
  }
}

const api = axios.create({
  baseURL: API,
  withCredentials: true, // also send cookies if available
});

// Attach Authorization: Bearer <token> when we have one in localStorage
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
